import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
//#endregion
//#region components
import { PageLayouts, useCheckRelations } from "components/common";
import RevisorViewDashboardContent from "./dashboardContent";
import RevisorDashboardTitle from "./title";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const RevisorDashboard: React.FC = (props) => {
  const { getIsRevisor } = useCheckRelations();
  const isRevisor = getIsRevisor();
  const isAuditorAssistant = useSelector((state: AppState) => state.auth.selectedCompany.loggedInUserIsAuditorAssistant);

  return (
    <PageLayouts.DashboardLayout
      entityKey={0}
      hasPermissions={isRevisor || isAuditorAssistant}
      className={cssExports.revisorDashboard}
      title={<RevisorDashboardTitle />}
      breadCrumb={<></>}
    >
      <RevisorViewDashboardContent />
    </PageLayouts.DashboardLayout>
  );
};

export default RevisorDashboard;
